import { useEffect } from "react";

export const useVisibilityChange = (
  handleVisibilityChange: (visible: boolean) => void
) => {
  const doc: Document & { msHidden?: boolean; webkitHidden?: boolean } =
    document;
  let hidden: "hidden" | "msHidden" | "webkitHidden" = "hidden";
  let visibilityChange = "";

  if (typeof doc.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof doc.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof doc.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }

  const onVisibilityChange = (): void => {
    if (doc[hidden]) {
      handleVisibilityChange(false);
    } else {
      handleVisibilityChange(true);
    }
  };

  useEffect(() => {
    document.addEventListener(visibilityChange, onVisibilityChange, false);
    return () =>
      document.removeEventListener(visibilityChange, onVisibilityChange, false);
  }, [handleVisibilityChange]);
};
